import { IClient } from "intake_shared/src/types";
import { Dialog } from "../../../../bits/Dialog/Dialog";
import moment from "../../../../../../utils/app_moment";
import EmptyListState from "../../../../bits/EmptyListState/EmptyListState";
import Skeleton from "../../../../bits/Skeleton/Skeleton";
import {
    getPriorityLabel,
    getStatusLabel,
    PRIORITY_COLORS,
    TICKETS_STATUS_COLORS,
} from "../../../../../../constants";
import styles from "./SupportConversation.module.scss";
import { Badge } from "../../../../bits/Badge/Badge";

interface SupportConversationProps {
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    selectedTicket: any;
    conversationsLoading: boolean;
    client: IClient;
    conversations: any;
}

export default function SupportConversation({
    isModalOpen,
    setIsModalOpen,
    selectedTicket,
    conversationsLoading,
    client,
    conversations,
}: SupportConversationProps) {
    const handleAddReply = () => {
        const link = document.createElement("a");
        link.href = `https://humantoldmanagement-help.freshdesk.com/a/tickets/${selectedTicket?.id}`;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
    };

    return (
        <Dialog
            open={isModalOpen}
            wrapperClassName={styles.supportConversationDialog}
            onClose={() => setIsModalOpen(false)}
            title={`Ticket #${selectedTicket?.id} - ${selectedTicket?.subject}`}
            showFooter={true}
            onSave={handleAddReply}
            saveText="Add a reply to this ticket"
        >
            <div className={styles.supportConversationWrapper}>
                <div className={styles.supportConversationGrid}>
                    <div className={styles.supportConversationSidebar}>
                        <div className={styles.sidebarItem}>
                            <p>Status</p>
                            <span>
                                <Badge
                                    content={getStatusLabel(selectedTicket?.status)}
                                    bgColor={
                                        TICKETS_STATUS_COLORS[selectedTicket?.status]
                                    }
                                    textColor="white"
                                />
                            </span>
                        </div>
                        <div className={styles.sidebarItem}>
                            <p>Priority</p>
                            <span>
                                <Badge
                                    content={getPriorityLabel(
                                        selectedTicket?.priority
                                    )}
                                    bgColor={
                                        PRIORITY_COLORS[selectedTicket?.priority]
                                    }
                                    textColor="white"
                                />
                            </span>
                        </div>
                        <div className={styles.sidebarItem}>
                            <p>Client</p>
                            <span>{`${client.first_name} ${client.last_name}`}</span>
                        </div>
                    </div>
                    <div className={styles.supportConversationMain}>
                        {conversationsLoading ? (
                            <Skeleton />
                        ) : (
                            <div>
                                {!conversations || conversations?.length === 0 ? (
                                    <EmptyListState
                                        emptyMessage="No messages yet"
                                        stateHelperText="This ticket doesn't have any conversation history. Send a message to start the conversation."
                                    />
                                ) : (
                                    <div style={{ paddingBottom: 10 }}>
                                        {conversations?.map((message, index) => (
                                            <div key={index}>
                                                <p>{message?.body_text}</p>
                                                <p className="text-muted-small">
                                                    {moment(
                                                        message?.created_at
                                                    ).format("MMM DD, YYYY hh:mm A")}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
